import type { Dispatch, SetStateAction } from 'react';
import { memo, useCallback } from 'react';
import type { SelectChangeEvent } from '@mui/material';
import { MenuItem, Typography } from '@mui/material';
import { Select, Wrapper } from './RowsPerPage.styles';
import { useTranslation } from 'react-i18next';

const PAGE_COUNTS = ['5', '10', '20', '50', '100'];

interface Props {
  rowsPerPage: number;
  showAll: boolean;
  setRowsPerPage: Dispatch<
    SetStateAction<{
      pageSize: number;
      pageIndex: number;
    }>
  >;
  zIndex?: number;
  disabled?: boolean;
  dataTestId?: string;
  testIdPrefix?: string;
}

export const RowsPerPage = memo(({ rowsPerPage, showAll, setRowsPerPage, zIndex, disabled, dataTestId, testIdPrefix }: Props) => {
  const { t } = useTranslation();
  const resolvedDataTestId = testIdPrefix ? `${testIdPrefix}-pagination-page-size-select` : 'pagination-page-size-select';
  const handleChangeRowsPerPage = useCallback(
    (event: SelectChangeEvent<unknown>) =>
      setRowsPerPage((prev) => ({
        ...prev,
        pageSize: Number(event.target.value),
      })),
    [setRowsPerPage]
  );
  return (
    <Wrapper>
      <Typography>{t('table.footer.rowsPerPage')}</Typography>
      <Select
        data-testid={dataTestId ?? resolvedDataTestId}
        value={rowsPerPage.toString()}
        onChange={handleChangeRowsPerPage}
        disabled={disabled}
        MenuProps={{
          sx: zIndex ? { zIndex } : undefined,
        }}>
        {PAGE_COUNTS.map((count, index) => (
          <MenuItem key={index} value={count}>
            {count}
          </MenuItem>
        ))}
        {showAll && <MenuItem value={9999}>{t('common.showAll')}</MenuItem>}
      </Select>
    </Wrapper>
  );
});
